// extracted by mini-css-extract-plugin
export default {"pivotMenu":"styles_pivotMenu__s3inb","label":"styles_label__xaUhK"};